import { useEffect, useRef } from 'react';
import DatePicker from 'react-multi-date-picker';
import DateObject from 'react-date-object';
import styles from './DatePicker.module.css';
import { DATE_FORMAT_HUMAN } from '@/constants/date.constants';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import transition from 'react-element-popper/animations/transition';
import { WithClassName } from '@/types/component';
import { cn } from '@/utils/shad';

const MAX_DATE = new Date();
const ANIMATIONS = [transition({ duration: 300, from: 35 })];

interface IProps {
  onClose: () => void;
  value: DateObject | null;
  onChange: (value: DateObject | null) => void;
  portal?: boolean;
  containerClassname?: string;
}

export const GenericDatePicker = ({
  onChange,
  onClose,
  value,
  portal,
  containerClassname,
  className,
}: IProps & WithClassName) => {
  const datePickerRef = useRef(null);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    datePickerRef.current?.openCalendar();
  }, []);

  return (
    <DatePicker
      ref={datePickerRef}
      onClose={() => {
        onClose();
      }}
      animations={ANIMATIONS}
      value={value}
      format={DATE_FORMAT_HUMAN}
      onChange={onChange}
      containerClassName={containerClassname}
      portal={portal}
      range={false}
      maxDate={MAX_DATE}
      arrow={false}
      render={() => <></>}
      calendarPosition="bottom-left"
      zIndex={1300}
      style={{
        width: '1000px',
      }}
      className={cn(styles.datePicker, className)}
    />
  );
};
